<!-- Start VoC Banner Section -->
<section class="ecb-web-voc-banner-section">

  <!-- Start VoC Banner Overlay -->
  <div class="ecb-web-voc-banner-overlay"></div>
  <!-- End VoC Banner Overlay -->

  <div class="container ecb-web-voc-banner-container hero-inner">
    <div class="row align-items-center">

      <!-- Start VoC Banner Content -->
      <div class="col-12 col-lg-6">
        <div class="ecb-web-voc-banner-content">

        
          <!-- Display the workplace health and safety category label. -->
          <span class="pill">VOC - Verification of Competency</span>
          <!-- Display the main HSR Training heading. -->

          <h1>Verification of Competency (VoC)</h1>

          <div class="ecb-web-voc-title-line"></div>

          <p class="ecb-web-voc-banner-description">
            Our Verification of Competency (VoC) assessments allow experienced
            workers to demonstrate their skills and current industry knowledge
            to meet licensing and workplace requirements.
          </p>

         


          <div class="ecb-web-voc-request-card">

            <!-- Start VOC Request Heading Section -->
            <div class="ecb-web-voc-request-heading">
              <h3>Complete the VoC Request Form</h3>

              <p>
                Choose how you would like to submit your VoC request.
              </p>
            </div>
            <!-- End VOC Request Heading Section -->


            <!-- Start VOC Request Options Section -->
            <div class="row g-3">

              <!-- Start Download Form Option -->
              <div class="col-12 col-md-6">

                <div class="ecb-web-voc-request-option">

                  <div class="ecb-web-voc-request-icon">
                    <i class="bi bi-file-earmark-pdf"></i>
                  </div>

                  <div class="ecb-web-voc-request-option-content">

                    <h4>Download PDF Form</h4>

                    <p>
                      Download the VoC request form and complete it manually.
                    </p>

                    <a href="/assets/documents/voc-request-form.pdf" download class="btn ecb-web-voc-request-button">

                      <span>Download Form</span>

                      <i class="bi bi-download"></i>

                    </a>

                  </div>

                </div>

              </div>
              <!-- End Download Form Option -->


              <!-- Start Online Form Option -->
              <div class="col-12 col-md-6">

                <div class="
        ecb-web-voc-request-option
        ecb-web-voc-request-online-option
      ">

                  <div class="ecb-web-voc-request-icon">
                    <i class="bi bi-ui-checks"></i>
                  </div>

                  <div class="ecb-web-voc-request-option-content">

                    <h4>Fill Online Form</h4>

                    <p>
                      Complete and submit your VoC request directly online.
                    </p>

                    <a routerLink="/corporate-form" class="
              btn
              ecb-web-voc-request-button
              ecb-web-voc-online-button
            ">

                      <span>Start Online Form</span>

                      <i class="bi bi-arrow-right"></i>

                    </a>

                  </div>

                </div>

              </div>
              <!-- End Online Form Option -->

            </div>
            <!-- End VOC Request Options Section -->

          </div>
          <!-- End Download Form Card -->

        </div>
      </div>
      <!-- End VoC Banner Content -->


      <!-- Start Banner Benefits -->
      <div class="col-12 col-lg-3">
        <div class="ecb-web-voc-banner-benefits">

          

        </div>
      </div>
      <!-- End Banner Benefits -->

    </div>
  </div>
</section>
<!-- End VoC Banner Section -->

 




<!-- Start VoC Assessments Section -->
<section class="ecb-web-voc-assessments-section">
  <div class="container">

    <app-x-voc-list></app-x-voc-list>
    <!-- <div class="ecb-web-voc-section-heading">
      <h2>VoC Assessments We Offer</h2>
      <div class="ecb-web-voc-section-heading-line"></div>
    </div>

    <div class="position-relative ecb-web-voc-assessment-slider-wrapper">
      <div #assessmentSlider class="ecb-web-voc-assessment-slider" (scroll)="updateAssessmentButtons()">
        <div class="ecb-web-voc-assessment-slide" *ngFor="
      let assessment of vocAssessments;
      trackBy: trackByVocAssessment
    ">
          <article class="ecb-web-voc-assessment-card">

            <div class="ecb-web-voc-assessment-image-wrapper">
              <img [src]="
            assessment.imageUrl ||
            '/assets/images/voc/default-course.webp'
          " [alt]="assessment.courseName" class="img-fluid ecb-web-voc-assessment-image">
            </div>

            <div class="ecb-web-voc-assessment-content">
              <h3>{{ assessment.courseName }}</h3>

              <p>{{ assessment.shortDescription }}</p>

              <button type="button" class="ecb-web-voc-assessment-link" data-bs-toggle="modal"
                data-bs-target="#vocCourseDetailsModal" (click)="openAssessmentDetails(assessment)">
                View Details
                <i class="bi bi-arrow-right"></i>
              </button>
            </div>

          </article>
        </div>
      </div>

    
      <button *ngIf="showAssessmentPreviousButton" type="button" class="btn ecb-web-voc-assessment-nav-button
         ecb-web-voc-assessment-prev-button" aria-label="View previous assessment" (click)="scrollAssessments('left')">
        <i class="bi bi-chevron-left"></i>
      </button>

       
      <button *ngIf="showAssessmentNextButton" type="button" class="btn ecb-web-voc-assessment-nav-button
         ecb-web-voc-assessment-next-button" aria-label="View next assessment" (click)="scrollAssessments('right')">
        <i class="bi bi-chevron-right"></i>
      </button>
    </div> -->
  </div>
</section>
<!-- End VoC Assessments Section -->

<!-- Start VoC Upload Section -->
<section class="ecb-web-voc-upload-section">
  <div class="container">

    <div class="ecb-web-voc-upload-card">
      <div class="row align-items-center g-4">

        <!-- Start Upload Description -->
        <div class="col-12 col-lg-3">
          <div class="ecb-web-voc-upload-description">

            <div class="ecb-web-voc-upload-description-icon">
              <i class="bi bi-cloud-arrow-up"></i>
            </div>

            <div>
              <h2>Upload Completed VoC Request Form</h2>

              <p>
                Once completed, upload your form using the secure upload option
                below. Our team will contact you to confirm your assessment.
              </p>
            </div>

          </div>
        </div>
        <!-- End Upload Description -->

        <!-- Start File Selection -->
        <div class="col-12 col-lg-3">

          <!-- Upload area -->
          <label for="vocFormFile" class="ecb-web-voc-file-upload-area" *ngIf="!formUrl">

            <span>
              Drag &amp; drop your file here
            </span>

            <small>or</small>

            <i class="bi bi-cloud-arrow-up"></i>

            <span class="btn ecb-web-voc-file-choose-button">
              {{ isVocFileUploading ? 'Uploading...' : 'Choose File' }}
            </span>

            <input #vocFormFileInput id="vocFormFile" type="file" accept="application/pdf" hidden
              [disabled]="isVocFileUploading" (change)="onVocFileSelected($event)">
          </label>

          <!-- Uploading message -->
          <div class="ecb-web-voc-uploading-message" *ngIf="isVocFileUploading">

            <i class="bi bi-arrow-repeat ecb-web-voc-spin"></i>

            <span>Uploading PDF...</span>
          </div>

          <!-- Uploaded file -->
          <div class="ecb-web-voc-uploaded-file" *ngIf="formUrl && !isVocFileUploading">

            <div class="ecb-web-voc-uploaded-file-details">

              <i class="bi bi-file-earmark-pdf-fill"></i>

              <div>
                <strong>
                  {{ selectedVocFileName || 'VOC Form.pdf' }}
                </strong>

                <span>
                  PDF uploaded successfully
                </span>
              </div>

            </div>

            <div class="ecb-web-voc-uploaded-file-actions">

              <a [href]="formUrl" target="_blank" rel="noopener noreferrer" class="btn ecb-web-voc-file-view-button">

                <i class="bi bi-eye"></i>
                View PDF
              </a>

              <button type="button" class="btn ecb-web-voc-file-remove-button" (click)="removeVocFile()">

                <i class="bi bi-trash"></i>
                Remove
              </button>

            </div>

          </div>

          <!-- Error -->
          <p class="ecb-web-voc-file-error" *ngIf="vocFileErrorMessage">

            {{ vocFileErrorMessage }}
          </p>

        </div>
        <!-- End File Selection -->

        <!-- Start Upload Form -->
        <div class="col-12 col-lg-3">
          <form (ngSubmit)="uploadVocForm()">

            <div class="mb-2">
              <label for="vocEmailAddress" class="form-label ecb-web-voc-email-label">
                Your Email Address <span>*</span>
              </label>

              <input id="vocEmailAddress" type="email" name="vocEmailAddress"
                class="form-control ecb-web-voc-email-input" placeholder="name@example.com"
                [(ngModel)]="vocEmailAddress" required>
            </div>

            <div *ngIf="successMessage" class="alert alert-success py-2 mb-2" role="alert">
              {{ successMessage }}
            </div>

            <div *ngIf="errorMessage" class="alert alert-danger py-2 mb-2" role="alert">
              {{ errorMessage }}
            </div>

            <button type="submit" class="btn w-100 ecb-web-voc-upload-button" [disabled]="isUploading">

              <span *ngIf="!isUploading">Upload Form</span>
              <span *ngIf="isUploading">Uploading...</span>
            </button>

          </form>
        </div>
        <!-- End Upload Form -->

        <!-- Start Security Message -->
        <div class="col-12 col-lg-3">
          <div class="ecb-web-voc-security-card">

            <div class="ecb-web-voc-security-icon">
              <i class="bi bi-lock"></i>
            </div>

            <div>
              <h3>Your information is secure</h3>
              <p>
                We respect your privacy and keep your information safe.
              </p>
            </div>

          </div>
        </div>
        <!-- End Security Message -->

      </div>
    </div>
  </div>
</section>
<!-- End VoC Upload Section -->

<!-- Start VoC Contact Bar -->
<!-- <section class="ecb-web-voc-contact-bar">
  <div class="container">

    <div class="row align-items-center justify-content-center">

      <div class="col-12 col-md-4">
        <div class="ecb-web-voc-contact-item">
          <i class="bi bi-geo-alt-fill"></i>
          <span>Multiple Locations Across Victoria</span>
        </div>
      </div>

      <div class="col-12 col-md-4">
        <a href="tel:0893580000" class="ecb-web-voc-contact-item">
          <i class="bi bi-telephone"></i>
          <span>1300 322 486</span>
        </a>
      </div>

      <div class="col-12 col-md-4">
        <a href="mailto:admin@ecbtraining.com.au" class="ecb-web-voc-contact-item">
          <i class="bi bi-envelope"></i>
          <span>admin ecbtraining.com.au</span>
        </a>
      </div>

    </div>
  </div>
</section> -->
<!-- End VoC Contact Bar -->


<!-- Start VOC Course Details Modal -->
<div class="modal fade" id="vocCourseDetailsModal" tabindex="-1" aria-labelledby="vocCourseDetailsModalLabel"
  aria-hidden="true">

  <div class="modal-dialog ecb-web-voc-modal-dialog">

    <div class="modal-content ecb-web-voc-modal-content" *ngIf="selectedAssessment">

      <!-- Start Modal Header Section -->
      <header class="modal-header ecb-web-voc-modal-header">

        <div class="ecb-web-voc-modal-header-overlay"></div>

        <img [src]="
            selectedAssessment.imageUrl ||
            '/assets/images/voc/default-course.webp'
          " [alt]="selectedAssessment.courseName" class="ecb-web-voc-modal-header-image">

        <div class="ecb-web-voc-modal-heading">

          <span class="ecb-web-voc-modal-label">
            Verification of Competency
          </span>

          <h2 id="vocCourseDetailsModalLabel" class="modal-title ecb-web-voc-modal-title">

            {{ selectedAssessment.courseName }}
          </h2>

          <small class="ecb-web-voc-modal-code" *ngIf="selectedAssessment.courseCode">

            {{ selectedAssessment.courseCode }}
          </small>

          <p class="ecb-web-voc-modal-short-description">
            {{ selectedAssessment.shortDescription }}
          </p>

        </div>

        <button type="button" class="btn-close ecb-web-voc-modal-close" data-bs-dismiss="modal" aria-label="Close">
        </button>

      </header>
      <!-- End Modal Header Section -->

      <!-- Start Modal Body Section -->
      <div class="modal-body ecb-web-voc-modal-body">

        <!-- Start Full Description Section -->
        <section class="ecb-web-voc-modal-description">

          <div class="ecb-web-voc-modal-description-icon">
            <i class="bi bi-shield-check"></i>
          </div>

          <p>
            {{ selectedAssessment.fullDescription }}
          </p>

        </section>
        <!-- End Full Description Section -->

        <div class="row g-2">

          <!-- Start Assessment Units Section -->
          <div class="col-12 col-lg-7">

            <section class="ecb-web-voc-modal-card h-100">

              <h3 class="ecb-web-voc-modal-section-title">
                Assessment Covers
              </h3>

              <div *ngIf="selectedAssessment.units?.length" class="row g-2">

                <div class="col-12 col-md-6" *ngFor="
                    let unit of selectedAssessment.units;
                    trackBy: trackByUnit
                  ">

                  <article class="ecb-web-voc-modal-unit">

                    <div class="ecb-web-voc-modal-unit-icon">
                      <i [class]="unit.icon || 'fa fa-check'"></i>
                    </div>

                    <div class="ecb-web-voc-modal-unit-content">

                      <h4>
                        {{ unit.name }}
                      </h4>

                      <p>
                        {{ unit.description }}
                      </p>

                    </div>

                  </article>

                </div>

              </div>

              <div *ngIf="!selectedAssessment.units?.length" class="ecb-web-voc-modal-empty-message">

                No assessment units are currently available.
              </div>

            </section>

          </div>
          <!-- End Assessment Units Section -->

          <!-- Start Course Details Section -->
          <div class="col-12 col-lg-5">

            <section class="ecb-web-voc-modal-card">

              <h3 class="ecb-web-voc-modal-section-title">
                Course Details
              </h3>

              <div class="ecb-web-voc-modal-detail-row">

                <div class="ecb-web-voc-modal-detail-label">
                  <i class="bi bi-clock"></i>
                  <strong>Duration</strong>
                </div>

                <span style="margin-top: 2px;font-size: 12px;">
                  {{ selectedAssessment.duration || '-' }}
                </span>

              </div>

              <!-- Suitable For -->
              <div class="ecb-web-voc-modal-detail-row">

                <div class="ecb-web-voc-modal-detail-label">
                  <i class="bi bi-person"></i>
                  <strong>Suitable For</strong>
                </div>

                <div class="assessment-content-wrapper">

                  <!-- Show only first 50 text characters -->
                  <span class="assessment-html-content">
                    {{ getContentPreview(selectedAssessment.suitableFor, 20) }}
                    <span *ngIf="isContentLong(selectedAssessment.suitableFor, 20)">...</span>
                  </span>

                  <!-- Show info icon only when content exceeds 50 characters -->
                  <span *ngIf="isContentLong(selectedAssessment.suitableFor, 20)" class="assessment-info-tooltip"
                    tabindex="0">

                    <i class="bi bi-info-circle-fill"></i>

                    <span class="assessment-tooltip-content" [innerHTML]="selectedAssessment.suitableFor | safeHtml">
                    </span>

                  </span>

                </div>

              </div>


              <!-- Outcome -->
              <div class="ecb-web-voc-modal-detail-row">

                <div class="ecb-web-voc-modal-detail-label">
                  <i class="bi bi-award"></i>
                  <strong>Outcome</strong>
                </div>

                <div class="assessment-content-wrapper">

                  <!-- Show only first 50 text characters -->
                  <span class="assessment-html-content">
                    {{ getContentPreview(selectedAssessment.outComes, 20) }}
                    <span *ngIf="isContentLong(selectedAssessment.outComes, 20)">...</span>
                  </span>

                  <!-- Show info icon only when content exceeds 50 characters -->
                  <span *ngIf="isContentLong(selectedAssessment.outComes, 20)" class="assessment-info-tooltip"
                    tabindex="0">

                    <i class="bi bi-info-circle-fill"></i>

                    <span class="assessment-tooltip-content" [innerHTML]="selectedAssessment.outComes | safeHtml">
                    </span>

                  </span>

                </div>

              </div>

              <div class="ecb-web-voc-modal-detail-row">

                <div class="ecb-web-voc-modal-detail-label">
                  <i class="bi bi-geo-alt"></i>
                  <strong>Locations</strong>
                </div>

                <span class="assessment-html-content" [innerHTML]="selectedAssessment.locations | safeHtml">

                </span>

              </div>

            </section>

            <!-- Start Course Fee Section -->
            <section class="ecb-web-voc-modal-price-card">

              <div class="ecb-web-voc-modal-price-icon">
                <i class="bi bi-tag-fill"></i>
              </div>

              <div>

                <small>
                  Course Fee
                </small>

                <h3>
                  {{ selectedAssessment.currencyCode }}
                  $
                  {{ selectedAssessment.price | number:'1.2-2' }}
                </h3>

                <p>
                  All prices include GST
                </p>

              </div>

            </section>
            <!-- End Course Fee Section -->

          </div>
          <!-- End Course Details Section -->

        </div>

        <!-- Start Bottom Section -->
        <div class="row g-2 mt-2">

          <!-- Start Enquiry Section -->
          <div class="col-12 col-lg-7">

            <section class="ecb-web-voc-modal-card h-100">

              <h3 class="ecb-web-voc-modal-section-title">
                Enquire Now
              </h3>

              <p class="ecb-web-voc-modal-enquiry-description">
                Please fill out the form below and our team will get back to you shortly.
              </p>

              <div class="row g-2">

                <div class="col-12 col-md-6">

                  <label for="vocEnquiryName" class="form-label ecb-web-voc-modal-form-label">

                    Your Name
                  </label>

                  <div class="input-group input-group-sm">

                    <span class="input-group-text">
                      <i class="bi bi-person-fill"></i>
                    </span>

                    <input id="vocEnquiryName" type="text" class="form-control" placeholder="Your Name">

                  </div>

                </div>

                <div class="col-12 col-md-6">

                  <label for="vocEnquiryEmail" class="form-label ecb-web-voc-modal-form-label">

                    Email Address
                  </label>

                  <div class="input-group input-group-sm">

                    <span class="input-group-text">
                      <i class="bi bi-envelope"></i>
                    </span>

                    <input id="vocEnquiryEmail" type="email" class="form-control" placeholder="Your Email Address">

                  </div>

                </div>

                <div class="col-12">

                  <button type="button" class="btn ecb-web-voc-modal-enquiry-button w-100">

                    Send Enquiry
                    <i class="bi bi-arrow-right ms-1"></i>

                  </button>

                </div>

              </div>

            </section>

          </div>
          <!-- End Enquiry Section -->

          <!-- Start Contact Section -->
          <div class="col-12 col-lg-5">

            <section class="ecb-web-voc-modal-card h-100">

              <h3 class="ecb-web-voc-modal-section-title">
                Contact ECB Training
              </h3>

              <ul class="ecb-web-voc-modal-contact-list">

                <li>
                  <i class="bi bi-telephone-fill"></i>
                  <span> 1300 322 486</span>
                </li>

                <li>
                  <i class="bi bi-envelope-fill"></i>
                  <span>admin&#64;ecbtraining.com.au</span>
                </li>

                <li>
                  <i class="bi bi-geo-alt-fill"></i>
                  <span>Multiple Locations Across Victoria</span>
                </li>

                <li>
                  <i class="bi bi-globe"></i>
                  <span>www.ecbtraining.com.au</span>
                </li>

              </ul>

            </section>

          </div>
          <!-- End Contact Section -->

        </div>
        <!-- End Bottom Section -->

      </div>
      <!-- End Modal Body Section -->

      <!-- Start Modal Footer Section -->
      <footer class="ecb-web-voc-modal-footer">

        <div class="ecb-web-voc-modal-footer-content">

          <div class="ecb-web-voc-modal-footer-icon">
            <i class="bi bi-shield-check"></i>
          </div>

          <div>

            <strong>
              ECB Training – Building Skills, Creating Safer Workplaces
            </strong>

            <p>
              Nationally Recognised Training · Experienced Assessors · Quality Outcomes
            </p>

          </div>

        </div>

        <div class="ecb-web-voc-modal-footer-brand">
          ECB
          <small>Training</small>
        </div>

      </footer>
      <!-- End Modal Footer Section -->

    </div>

  </div>

</div>
<!-- End VOC Course Details Modal -->